import React from "react";
import useStyles from "./stylesComponents";
import { Input } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
function SearchBar() {
  const { classes } = useStyles();
  return (
        <Input
          radius={"md"}
          icon={<IconSearch />}
          placeholder="Search Documents..."
        />
  );
}

export default SearchBar;

